import { Create, getValueFromEvent, useFileUploadState, useForm, useSelect } from "@refinedev/antd";
import { FileTextOutlined, InboxOutlined, CompassOutlined } from "@ant-design/icons";
import { Form, Input, Select, Tag, Upload, Space } from "antd";
import { IResourceComponentsProps, useApiUrl } from "@refinedev/core";
import { ICountry, INoticesMariners } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

import React from "react";

export const NoticesMarinersCreate: React.FC<IResourceComponentsProps> = () => {
  const [isFileUploaded, setIsFileUploaded] = React.useState(false);

  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<INoticesMariners>({ redirect: "list" });

  const { onChange, isLoading: isFileUploading } = useFileUploadState();
  const apiUrl = useApiUrl();

  function onFileUpload(e: any) {
    setIsFileUploaded(true);
    onChange(e);
  }

  const props = {
    name: "file",
    multiple: false,
    maxCount: 1,
    action: `${apiUrl}/upload/notices/mariners`,
    onChange: onFileUpload,
  };

  const { selectProps: countrySelectProps } = useSelect<ICountry>({
    resource: "country",
    optionLabel: "name",
    optionValue: "name",

    pagination: {
      mode: "server"
    }
  });

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={{
        ...saveButtonProps,
        disabled: isFileUploaded && !isFileUploading ? false : true,
      }}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Digital Bookshelf",
        subTitle: "notices to mariners",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          documentType: "Circular",
        }}
      >
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Notice Details"
            subtitle="Notices to mariners information"
            icon={<CompassOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Country"
                name={["country"]}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  style={{ minWidth: 200 }}
                  {...countrySelectProps}
                />
              </Form.Item>
              <Form.Item
                label="Title"
                name={["title"]}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input name="title" />
              </Form.Item>
              <Form.Item
                label="Week Number"
                name={["weekNumber"]}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input name="weekNumber" />
              </Form.Item>
              <Form.Item
                label="Year"
                name={["year"]}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input name="year" />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
          <FormSection
            title="File Upload"
            subtitle="Upload notice to mariners file"
            icon={<FileTextOutlined />}
            variant="elevated"
          >
            <Form.Item
              label="File"
              name="file"
              valuePropName="file"
              getValueFromEvent={getValueFromEvent}
            >
              <Upload.Dragger {...props} listType="picture">
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag & drop file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single upload of notice to mariners
                </p>
              </Upload.Dragger>
            </Form.Item>
          </FormSection>
        </Space>
      </Form>
    </Create>
  );
};
